// ══════════════════════════════════════════════════════════════════════════════
// SELDOR — Modal Component
// ══════════════════════════════════════════════════════════════════════════════

import { X } from 'lucide-react';
import { useEffect } from 'react';
import { useTheme } from '@contexts/ThemeContext';

export function Modal({ open, onClose, title, children, maxWidth = 480 }) {
  const { theme } = useTheme();

  useEffect(() => {
    if (!open) return;
    const handleEsc = (e) => e.key === 'Escape' && onClose?.();
    document.addEventListener('keydown', handleEsc);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', handleEsc);
      document.body.style.overflow = '';
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(0,0,0,0.55)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
        backdropFilter: 'blur(4px)',
        animation: 'fadeIn 0.2s ease-out'
      }}
      onClick={onClose}
    >
      <div
        onClick={e => e.stopPropagation()}
        style={{
          background: theme.bgCard,
          borderRadius: 16,
          border: `1px solid ${theme.border}`,
          boxShadow: theme.shadowElevated,
          width: '90%',
          maxWidth,
          maxHeight: '85vh',
          overflow: 'auto',
          animation: 'fadeIn 0.25s ease-out'
        }}
      >
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '18px 24px',
          borderBottom: `1px solid ${theme.border}`
        }}>
          <h3 style={{ margin: 0, fontSize: 16, fontWeight: 700, color: theme.text }}>
            {title}
          </h3>
          <X size={18} style={{ cursor: 'pointer', color: theme.textTertiary }} onClick={onClose} />
        </div>
        <div style={{ padding: 24 }}>{children}</div>
      </div>
    </div>
  );
}
